import React from 'react'
import { Container } from '@components/Globals'
import { Column, Row } from '@components/Common'
import Banner from '@components/Banner'
import {
  InsightsDetailMain,
  InsightsDetailNextTeaser,
  InsightsDetailSidebarContent,
} from './subcomponents'

const InsightsDetailContent = ({
  parentPath,
  crumbLabel = 'Insights',
  insight,
  next,
  ...rest
}) => {
  return (
    <Container fluid>
      <Row>
        <Column className="mb-10">
          <Banner
            stacked
            breadcrumbs
            height="22"
            to={parentPath}
            crumbLabel={crumbLabel}
            crumbClassName="qtph-insightspage-allinsights-link"
            gradient="blue-gold"
          >
            <InsightsDetailMain
              parentPath={parentPath}
              crumbLabel={crumbLabel}
              articleGrid={insight?.articleGrid}
              {...insight}
            />
            <InsightsDetailNextTeaser
              next={next}
              {...insight}
              contentType={insight?.__typename}
            />
            <Column className="max-w-135 w-full my-5 mx-auto md:w-[26%] md:mt-[55px] md:ml-10 xl:ml-[8.3%]">
              <InsightsDetailSidebarContent
                {...insight}
                practiceAreas={
                  insight?.associatedPracticeAreas || insight?.practiceAreas
                }
              />
            </Column>
          </Banner>
        </Column>
      </Row>
    </Container>
  )
}

export default InsightsDetailContent
